module.exports = __webpack_public_path__ + "img/Talk-It-Through-Icon.29dcb7e9.svg";